import { useMemo } from "react";
import { motion } from "framer-motion";

const R = 52;
const CIRC = 2 * Math.PI * R;
const INITIAL = { strokeDashoffset: CIRC };
const TRANSITION = { duration: 1.1, ease: [0.22, 1, 0.36, 1] };

export const HudRing = ({ value = 0, label, display, color = "var(--au-green)", size = 132, testId }) => {
  const v = Math.max(0, Math.min(1, value));
  const box = useMemo(() => ({ width: size, height: size }), [size]);
  const animate = useMemo(() => ({ strokeDashoffset: CIRC * (1 - v) }), [v]);
  const glow = useMemo(() => ({ filter: `drop-shadow(0 0 6px ${color})` }), [color]);
  return (
    <div className="flex flex-col items-center gap-3" data-testid={testId}>
      <div className="relative" style={box}>
        <svg viewBox="0 0 132 132" className="absolute inset-0 hud-ring-spin-slow">
          <circle cx="66" cy="66" r="62" fill="none" stroke="currentColor" className="text-foreground/10" strokeDasharray="2 6" />
        </svg>
        <svg viewBox="0 0 132 132" className="absolute inset-0 -rotate-90">
          <circle cx="66" cy="66" r={R} fill="none" stroke="currentColor" className="text-foreground/10" strokeWidth="6" />
          <motion.circle cx="66" cy="66" r={R} fill="none" stroke={color} strokeWidth="6" strokeLinecap="butt"
            strokeDasharray={CIRC} initial={INITIAL} animate={animate} transition={TRANSITION} style={glow} />
        </svg>
        <svg viewBox="0 0 132 132" className="absolute inset-0 hud-ring-spin-rev">
          <path d="M66 10 A56 56 0 0 1 122 66" fill="none" stroke={color} strokeOpacity="0.5" strokeWidth="1" />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-mono text-2xl font-semibold tabular-nums">{display}</span>
        </div>
      </div>
      <span className="mono-label">{label}</span>
    </div>
  );
};
